import Banner from 'componentes/Banner'
import React, { useEffect, useState } from 'react'
import styles from './SobreMim.module.css'

export default function SobreMim() {
    const [idade, setIdade] = useState()

    const dataAtual = {
        dia: new Date().getDate(),
        mes: new Date().getMonth() + 1,
        ano: new Date().getFullYear()
    }

    useEffect(() => {
        if (dataAtual.mes === 12 && dataAtual.dia >= 3) {
            setIdade(dataAtual.ano - 1999)
        } else { setIdade((dataAtual.ano - 1999) - 1) }
    }, [])

    return (
        <>
            <Banner titulo={"Sobre mim"} className={styles.banner} />
            <ul className={styles.lista}>
                <li className={styles.item}>Olá, me chamo Bruno Bahy de Oliveira, tenho {idade} anos e estou estudando para ser Front-end com foco em React.js e Next.js.</li>
                <li className={styles.item}>Gosto de aprender coisas novas e ser desafiado, a sensação de superar obstáculos é o que me motiva a aprender mais e mais.</li>
                <li className={styles.item}>Estou a procura do meu primeiro emprego na área. Um dos meus pontos forte é que aprendo rápido e sempre estou disposto a cumprir novos desafios.</li>
                <li className={styles.item}>Quando não estou no trabalho estou estudando e aprimorando meus conhecimentos como desenvolvedor, mas quando canso de estudar gosto muito de jogar com os amigos.</li>
            </ul>
        </>
    )
}
